<app-logo class="spp-logo" [width]="'auto'" [logoImage]="'assets/logo/navy/spp-logo.svg'" />

<ng-container [ngSwitch]="viewModel.authFlow$ | async">
  <!--  Sign In Flow  -->
  <ng-container *ngSwitchCase="AuthFlow.SignIn">
    <app-sign-in (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Forgot Password Flow  -->
  <ng-container *ngSwitchCase="AuthFlow.ForgotPassword">
    <app-forgot-password (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Reset Password Flow  -->
  <ng-container *ngSwitchCase="AuthFlow.ResetPassword">
    <app-reset-password (loadingOpts)="loadingOpts.emit($event)" />
  </ng-container>
  <!--  Internal User Choose Password Flow  -->
  <ng-container *ngSwitchCase="AuthFlow.InternalUserChoosePassword">
    <app-internal-user-choose-password />
  </ng-container>
  <!--  Internal User Setup MFA Flow  -->
  <ng-container *ngSwitchCase="AuthFlow.InternalUserSetupMfa">
    <app-internal-user-auth-setup />
  </ng-container>
  <!--  Internal User Verify Code Flow  -->
  <ng-container *ngSwitchCase="AuthFlow.InternalVerifyCode">
    <app-internal-user-verify-code />
  </ng-container>
</ng-container>
